import styled from "@emotion/styled";
import React from "react";
import {StaticImage} from "gatsby-plugin-image";
import Quote from "../../common/Quote";

interface StoreProductImageProps {
    children: React.ReactNode;
    name: string;
    description: string;
    price: string;
    link_to: string;
}

StoreProductImage.defaultProps = {
    description: "",
}


export default function StoreProductImage(props: StoreProductImageProps) {
    return (
        <Container>
            <a href={props.link_to}>
            {props.children}
            <div className="products-item-info">
                <span className="item-name">{props.name}</span>
                <span className="item_desc"> {props.description}</span>
                <div className="item-cost">
                    <span className="item-cost-num">{props.price}</span>
                    <span className="item-cost-tax">(税込)</span>
                </div>
            </div>
            </a>
        </Container>
    );
}

const Container = styled.div`


  margin: 20px;

  @media (max-width: 768px) {
    margin: 10px;
  }

  .products-item-info {

    display: flex;
    flex-direction: column;
    text-align: center;
    color: #2F2F2F;
    padding-top: 12px;
    min-width: min(80vw, 360px);


    .item-name {
      display: block;
      margin-top: 0.6em;
      //font-family: YuMincho;
      font-weight: 500;
      font-size: 18px;
      letter-spacing: 0.05em;
      line-height: 17px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }

    .item_desc {
      display: block;

      font-weight: 500;
      font-size: 14px;
      letter-spacing: 0.05em;
      line-height: 22px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }

    .item-cost {
      display: block;
      margin-top: 0.8em;

      .item-cost-num {

        //font-family: Didot;
        font-style: italic;
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.05em;
        line-height: 17px;
        color: #2F2F2F;

        @media (max-width: 768px) {
          font-size: 14px;
        }
      }

      .item-cost-tax {
        padding-left: 5px;

        //font-family: YuMincho;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        letter-spacing: 0.05em;
        line-height: 17px;
        color: #2F2F2F;

        @media (max-width: 768px) {
          font-size: 10px;
        }
      }
    }
  }
`;
